import { useMemo, useLayoutEffect, useState } from "react";
export var useScrollLock = function (_a) {
    var showModal = _a.showModal;
    var documentBody = useMemo(function () { return document.querySelector("body"); }, []);
    var _b = useState(0), scrollY = _b[0], setScrollY = _b[1];
    useLayoutEffect(function () {
        if (documentBody) {
            if (showModal) {
                setScrollY(window.scrollY);
                documentBody.style.top = "-" + window.scrollY + "px";
                documentBody.style.left = "0";
                documentBody.style.bottom = "0";
                documentBody.style.right = "0";
                documentBody.style.position = "fixed";
            }
            if (!showModal) {
                documentBody.style.position = "";
                documentBody.style.top = "";
                documentBody.style.left = "";
                documentBody.style.bottom = "";
                documentBody.style.right = "";
                window.scrollTo(0, scrollY);
            }
        }
    }, [showModal, documentBody]);
};
